import { render, staticRenderFns } from "./PermissionPopover.vue?vue&type=template&id=67ad2e4e&scoped=true"
import script from "./PermissionPopover.vue?vue&type=script&lang=js"
export * from "./PermissionPopover.vue?vue&type=script&lang=js"
import style0 from "./PermissionPopover.vue?vue&type=style&index=0&id=67ad2e4e&lang=scss&scoped=true"
import style1 from "./PermissionPopover.vue?vue&type=style&index=1&id=67ad2e4e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad2e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\sdr\\KB\\Knowledge-base\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ad2e4e')) {
      api.createRecord('67ad2e4e', component.options)
    } else {
      api.reload('67ad2e4e', component.options)
    }
    module.hot.accept("./PermissionPopover.vue?vue&type=template&id=67ad2e4e&scoped=true", function () {
      api.rerender('67ad2e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/cloud-disk/src/components/PermissionPopover.vue"
export default component.exports